import { render, staticRenderFns } from "./SimpleExamModels.vue?vue&type=template&id=6685541c&"
import script from "./SimpleExamModels.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports